import memoryStorage from './memoryStorage'

const sessionStorageEnabled = () => {
  let enabled = true
  try {
    sessionStorage.getItem('session-storage-test')
  } catch (error) {
    enabled = false
  }
  return enabled
}

const storageEnabled = sessionStorageEnabled()
const availableStorage = storageEnabled ? sessionStorage : memoryStorage

class Storage {
  static setItem(key: string, value: unknown): void {
    availableStorage.setItem(key, JSON.stringify(value))
  }

  static getItem(key: string): any {
    const value = availableStorage.getItem(key)
    if (value) {
      return JSON.parse(value)
    }
    return null
  }

  static removeItem(key: string): void {
    availableStorage.removeItem(key)
  }
}

export default Storage
